// Mostra a data de vencimento de uma atividade com cor + label semântico
// (Atrasada Xd, Hoje, Amanhã, Em N dias, ou data formatada). Cinza neutro
// quando a atividade já foi concluída/cancelada.
import { Typography } from 'antd';
import { agoraSaoPaulo, rotuloDoPrazo } from './calendarioUtils';
import type { Atividade } from './types';

const { Text } = Typography;

interface Props {
  iso: string;
  status?: Atividade['status'];
}

export default function DataVencimento({ iso, status }: Props) {
  // Dias de Brasília a partir da data COMO ESTÁ GRAVADA (09/10/2026): com
  // `new Date(iso)` o "Z" da API puxava a meia-noite para o dia anterior.
  const r = rotuloDoPrazo(iso, agoraSaoPaulo().dia);
  if (!r) return <Text type="secondary" italic>—</Text>;
  const data = `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;
  // Atividades concluídas ou canceladas NÃO devem aparecer como "atrasada" —
  // o prazo já não importa mais. Mostra só a data formatada em cinza.
  const finalizada = status === 'concluida' || status === 'cancelada';
  if (finalizada) {
    return <Text style={{ color: '#888', fontWeight: 400, fontSize: 11 }}>{data}</Text>;
  }
  const cor = r.diff < 0 ? '#B91626' : r.diff === 0 ? '#B07500' : r.diff <= 3 ? '#0930D0' : '#666';
  return <Text style={{ color: cor, fontWeight: 500, fontSize: 11 }}>{r.texto}</Text>;
}
